import { render, staticRenderFns } from "./WalletTransfer.vue?vue&type=template&id=013456ed&"
import script from "./WalletTransfer.vue?vue&type=script&lang=ts&"
export * from "./WalletTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports